module.exports = __webpack_public_path__ + "dgrid.1dR8BaEM.png";